import React, { useState, useEffect } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react';
import { PopOut } from 'components/ui/icons';

const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  width: 50%;
`;

const IconButton = styled.button`
  background-color: #f7f7f9;
  border-radius: 5.87px;
  height: 40px;
  width: 40px;
  min-width: 40px;
  color: #8e8e93;

  :hover {
    color: #444444;
  }
`;
interface PropTypes {
  documents: string[];
  defaultDocument: string;
  documentUrl: string;
  setDocumentUrl: (docName: string) => void;
  orderId: string;
}

const documentOptions = (documents: string[]) => {
  if (!documents.length) return [];

  return documents.map(d => {
    const lastIndex = d.lastIndexOf('/');
    const documentName = lastIndex !== -1 ? d.substring(lastIndex + 1) : d;
    return {
      key: d,
      text: documentName,
      value: d,
    };
  });
};

const DocumentControl = (props: PropTypes) => {
  const [selectedDoc, setSelectedDoc] = useState<string>();
  useEffect(() => {
    if (props.defaultDocument) {
      setSelectedDoc(props.defaultDocument);
    }
  }, [props.defaultDocument]);
  return (
    <Wrapper>
      <b style={{ marginTop: 'auto', marginBottom: 'auto' }}>{`Files for Madison order ${props.orderId}:`}</b>
      <span style={{ width: '50%' }}>
        <Dropdown
          selection
          options={documentOptions(props.documents)}
          value={selectedDoc}
          onChange={(e, { value }) => {
            const doc = props.documents.find(d => d === value);
            setSelectedDoc(value as string);
            props.setDocumentUrl(value as string);
          }}
          placeholder="Select Document"
          fluid
        />
      </span>
      {props.documentUrl && (
        <Link to={props.documentUrl} target="_blank" replace>
          <IconButton>
            <PopOut />
          </IconButton>
        </Link>
      )}
    </Wrapper>
  );
};

export default DocumentControl;
